export default __webpack_public_path__ + "static/media/steps-cover-7.e021820d.png";